import React from 'react';
import styles from './Services.module.scss';
import { CAR_CERTIFICATIONS } from '../utils/Constants';
import Icon from './Icon';

export default function ResultIcons({ data }) {
	const resultCarCertifications = CAR_CERTIFICATIONS.filter(
		(carCertification) => data[carCertification.name]
	);

	return (
		<div className={styles.root}>
			{resultCarCertifications.map((resultCarCertification, index) => (
				<Icon icon={resultCarCertification.icon} key={index} />
			))}
		</div>
	);
}
